// extracted by mini-css-extract-plugin
export var active = "style-module--active--3b3e4";
export var contents = "style-module--contents--79cc9";
export var hasParent = "style-module--hasParent--8e1ec";
export var nav = "style-module--nav--b5a95";
export var navLink = "style-module--navLink--6a717";
export var section = "style-module--section--74235";
export var sectionName = "style-module--sectionName--28f95";
export var test = "style-module--test--4464a";